export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  PLAYER = 'ROLE_PLAYER'
}

export enum ActivationAction {
  ACTIVATE = 'activate',
  DEACTIVATE = 'deactivate'
}

export enum PublishingAction {
  PUBLISH = 'publish',
  UNPUBLISH = 'unpublish'
}

export enum EntityStatus {
  IMPORTED = 'imported',
  PUBLISHED = 'published',
  REMOVED = 'removed'
}

export enum StaticPageName {
  TERMS_OF_SERVICE = 'terms',
  PRIVACY_POLICY = 'privacy',
  ABOUT = 'about'
}
